/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';

import { type Endereco } from './types';

const editar = (endereco: Endereco): AxiosPromise<null> => xhr.put(`/enderecos/${endereco.id}`, endereco);

export default editar;
